import { render, staticRenderFns } from "./credenciales.vue?vue&type=template&id=4500b246&"
import script from "./credenciales.vue?vue&type=script&lang=js&"
export * from "./credenciales.vue?vue&type=script&lang=js&"
import style0 from "./credenciales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports